var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1364(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307.185,
    height: 375.375,
    viewBox: "0 0 307.185 375.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1364",
    "data-name": "Groupe 1364",
    transform: "translate(-283.366 -486.478)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_833",
    "data-name": "Trac\\xE9 833",
    d: "M6856.345,356.724c3.088-37.348,35.4-66.724,74.811-66.724s71.719,29.376,74.805,66.724Z",
    transform: "translate(-6419.341 351.19)",
    fill: "none",
    stroke: "#a128a8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_834",
    "data-name": "Trac\\xE9 834",
    d: "M7002.392-64.83V87.565H6850v-.114l2.056-2.055L7002.283-64.83Z",
    transform: "translate(-6412.841 552.308)",
    fill: "none",
    stroke: "#13b0eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 76.26,
    cy: 75.584,
    rx: 76.26,
    ry: 75.584,
    transform: "translate(436.471 709.685)",
    fill: "none",
    stroke: "#2b5bd3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_835",
    "data-name": "Trac\\xE9 835",
    d: "M6651.3,445.38V596.574H6499.373v-.113L6651.19,445.38Z",
    transform: "translate(-6215.007 263.098)",
    fill: "none",
    stroke: "#13b0eb",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1364);
export default __webpack_public_path__ + "static/media/Groupe_1364.3584dfe82b1f9c351da64c9af0e7b0d5.svg";
export { ForwardRef as ReactComponent };